// Curated list of countries where TGE students typically completed their
// high school. "Other" lets the student type a free-text value.
// Order: TGE's biggest source markets first, then alphabetical.
const COUNTRIES = [
  'India',
  'Pakistan',
  'Bangladesh',
  'Nepal',
  'Sri Lanka',
  'Philippines',
  'Nigeria',
  'Ghana',
  'Kenya',
  'United Arab Emirates',
  'Saudi Arabia',
  'China',
  'Vietnam',
  'Indonesia',
  'Iran',
  'Iraq',
  'Afghanistan',
  'Canada',
  'United States',
  'United Kingdom',
  'Australia',
  'Mexico',
  'Brazil',
  'Colombia',
  'Argentina',
  'South Africa',
  'Egypt',
  'Morocco',
  'Turkey',
  'Russia',
  'Ukraine',
  'Germany',
  'France',
  'Italy',
  'Spain',
  'Portugal',
  'Japan',
  'South Korea',
  'Singapore',
  'Malaysia',
  'Thailand',
  'New Zealand',
  'Other',
];

export default COUNTRIES;
